import { Component, Input, OnInit } from '@angular/core';
import { Borrower } from 'src/app/models';
import { UrlaMortgage } from 'src/app/modules/urla/models/urla-mortgage.model';

@Component({
    selector: 'tpo-borrower',
    templateUrl: 'tpo-borrower.component.html',
    styleUrls: ['./tpo-borrower.component.scss'],
    standalone: false
})
export class TpoBorrowerComponent implements OnInit {

  @Input()
  set borrowers(borrowers: Borrower[]) {
    if (borrowers) {
      this._borrowers = borrowers;
    }
    this.primaryBorrower = borrowers.find(b => b.isPrimary);
    const coBorrowers = borrowers.filter(b => !b.isPrimary);
    if (coBorrowers.length) {
      this.coBorrower = coBorrowers[0];
    }
    this.updateDisplayNames();
  }

  get borrowers(): Borrower[] {
    return this._borrowers;
  }

  @Input()
  set mortgage(mortgage: UrlaMortgage) {
    this._mortgage = mortgage;
    this.updateDisplayNames();
  }

  get mortgage(): UrlaMortgage {
    return this._mortgage;
  }

  primaryBorrower: Borrower;
  coBorrower: Borrower;

  /** Display name shown as the card heading; LLC name for Entity borrowers (see getDisplayName). */
  primaryBorrowerName: string;
  coBorrowerName: string;

  private _borrowers: Borrower[] = [];
  private _mortgage: UrlaMortgage;

  constructor() { }

  ngOnInit() {
  }

  /**
   * Recomputes the heading names. Both `borrowers` and `mortgage` are bound inputs that can
   * arrive in either order, so this is called from both setters and reads whatever is set so far.
   */
  private updateDisplayNames(): void {
    this.primaryBorrowerName = this.getDisplayName(this.primaryBorrower);
    this.coBorrowerName = this.getDisplayName(this.coBorrower);
  }

  /**
   * Returns the borrowing entity (LLC) name for an Entity borrower, otherwise the standard
   * "Last, First" display. Mirrors getLlcAwareBorrowerName in tpo-app-details: the entity name
   * lives on the mortgage's borrowing entity (URLA Borrower Info), matched to this Borrower via
   * the mortgage borrower's contactId.
   */
  private getDisplayName(borrower: Borrower): string {
    if (!borrower) {
      return '';
    }
    const mortgageBorrower = this._mortgage?.borrowers?.find(
      mb => mb.contactId === borrower.borrowerId
    );
    const entityName = this._mortgage?.extension?.borrowingEntity?.entityName;
    if (mortgageBorrower?.mortgagePartyType === 'Entity' && entityName) {
      return entityName;
    }
    return borrower.lastName + ", " + borrower.firstName;
  }
}
